/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBadgeHd = createReactComponent("outline", "badge-hd", "IconBadgeHd", [["path", { "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M14 9v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z", "key": "svg-1" }], ["path", { "d": "M7 15v-6", "key": "svg-2" }], ["path", { "d": "M10 15v-6", "key": "svg-3" }], ["path", { "d": "M7 12h3", "key": "svg-4" }]]);

export { IconBadgeHd as default };
//# sourceMappingURL=IconBadgeHd.mjs.map
